// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-100[data-v-39b45792]{height:100%}.min-h-100[data-v-39b45792]{min-height:100%!important}.negativ-margin[data-v-39b45792]{margin-bottom:-20px}", ""]);
// Exports
module.exports = exports;
